document.documentElement.classList.remove('no-js');

// Truly global: used by the product-page "add to cart" quantity field and by the cart
// drawer/page line items, so it has to be registered on every page, not just product pages.
class QuantitySelector extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('[data-quantity-input]');
    this.querySelector('[data-quantity-decrease]').addEventListener('click', () => this.step(-1));
    this.querySelector('[data-quantity-increase]').addEventListener('click', () => this.step(1));
  }

  step(delta) {
    const min = Number(this.input.min) || 0;
    const next = Math.max(min, (Number(this.input.value) || min) + delta);
    this.input.value = next;
    this.input.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

customElements.define('quantity-selector', QuantitySelector);
